(() => {
  const root = document.querySelector('[data-product-page]');
  if (!root) return;

  const productId = root.dataset.productId;
  const productUrl = root.dataset.productUrl;

  let variants = [];
  try { variants = JSON.parse(root.dataset.variants || '[]'); } catch (_) {}

  const priceFinal = root.querySelector('[data-price-final]');
  const variantIdInput = root.querySelector('[data-variant-id-input]');
  const atcBtn = root.querySelector('[data-atc]');
  const stickyBar = root.querySelector('[data-sticky-atc]');
  const stickyBtn = root.querySelector('[data-sticky-atc-btn]');
  const stickyPrice = root.querySelector('[data-sticky-price]');
  const qtyInput = root.querySelector('[data-qty-input]');
  const backInStockAnchor = root.querySelector('[data-app-back-in-stock]');

  const money = (cents) => {
    if (cents == null) return '';
    return '$' + (cents / 100).toFixed(2);
  };

  // ---------- Variant selection ----------
  const getSelectedOptions = () => {
    const inputs = root.querySelectorAll('[data-option-input]:checked');
    return Array.from(inputs).map((i) => i.value);
  };

  const findVariant = (opts) => {
    return variants.find((v) => {
      return v.options.every((val, i) => val === opts[i]);
    });
  };

  const updateOptionValueDisplay = (index, value) => {
    const legend = root.querySelector('[data-option-index="' + index + '"] [data-option-value]');
    if (legend) legend.textContent = value;
  };

  const updatePrice = (variant) => {
    if (!priceFinal || !variant) return;
    priceFinal.textContent = money(variant.price);
    if (stickyPrice) stickyPrice.textContent = money(variant.price);
    // Referencia en bolívares (snippets/bs-ref) con el mismo precio que se muestra
    const bsRef = root.querySelector('[data-bs-ref]');
    if (bsRef) {
      bsRef.dataset.cents = String(variant.price);
      if (window.nqBs) window.nqBs.render();
    }
  };

  const updateAtcState = (variant) => {
    if (!atcBtn) return;
    const available = variant && variant.available;
    atcBtn.disabled = !available;
    atcBtn.toggleAttribute('aria-disabled', !available);
    const label = atcBtn.querySelector('.product-page__atc-label');
    if (label) label.textContent = available ? 'AGREGAR AL CARRITO' : 'AGOTADO';
    if (backInStockAnchor) {
      backInStockAnchor.hidden = available;
      if (variant) backInStockAnchor.setAttribute('data-variant-id', String(variant.id));
    }
  };

  const updateUrl = (variantId) => {
    if (!productUrl) return;
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variantId));
      window.history.replaceState({}, '', url.toString());
    } catch (_) {}
  };

  const updateGalleryForVariant = (variant) => {
    if (!variant || !variant.featured_media) return;
    const mediaId = String(variant.featured_media.id);
    const thumb = document.querySelector('[data-thumb][data-media-id="' + mediaId + '"]');
    if (thumb) thumb.click();
  };

  // ---------- Urgencia: pocas unidades ----------
  const stockBox = root.querySelector('[data-stock-bajo]');
  let stockMap = {};
  if (stockBox) {
    try { stockMap = JSON.parse(stockBox.querySelector('[data-stock-map]').textContent); } catch (_) {}
  }
  const updateStock = (variant) => {
    if (!stockBox || !variant) return;
    const qty = stockMap[String(variant.id)] || 0;
    const umbral = parseInt(stockBox.dataset.umbral, 10) || 10;
    const show = qty > 0 && qty <= umbral;
    stockBox.hidden = !show;
    if (!show) return;
    const texto = stockBox.querySelector('[data-stock-texto]');
    if (texto) texto.textContent = (stockBox.dataset.texto || '').replace('[cantidad]', String(qty));
    const barra = stockBox.querySelector('[data-stock-barra]');
    if (barra) barra.style.setProperty('--stock', Math.max(8, Math.round((qty * 100) / umbral)) + '%');
  };

  const handleOptionChange = () => {
    const opts = getSelectedOptions();
    opts.forEach((v, i) => updateOptionValueDisplay(i, v));
    const variant = findVariant(opts);
    if (!variant) return;
    if (variantIdInput) variantIdInput.value = String(variant.id);
    root.setAttribute('data-current-variant-id', String(variant.id));
    // Actualiza el SKU si existe el bloque
    const skuEl = root.querySelector('[data-variant-sku]');
    if (skuEl) skuEl.textContent = variant.sku || '—';
    // Sincroniza con el input hook de MW Marketing Offers
    const mwInput = document.getElementById('variantIdBundle');
    if (mwInput) {
      mwInput.value = String(variant.id);
      mwInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    updatePrice(variant);
    updateAtcState(variant);
    updateStock(variant);
    updateUrl(variant.id);
    updateGalleryForVariant(variant);
  };

  root.querySelectorAll('[data-option-input]').forEach((el) => {
    el.addEventListener('change', handleOptionChange);
  });

  // ---------- Qty ----------
  root.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty]');
    if (!btn || !qtyInput) return;
    const dir = btn.dataset.qty === 'plus' ? 1 : -1;
    const next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + dir);
    qtyInput.value = String(next);
  });

  // ---------- Gallery ----------
  const gallery = root.querySelector('[data-product-gallery]');
  if (gallery) {
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = Array.from(gallery.querySelectorAll('[data-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
    const dots = Array.from(gallery.querySelectorAll('[data-dot]'));
    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');

    const goTo = (index) => {
      if (index < 0) index = 0;
      if (index >= slides.length) index = slides.length - 1;
      gallery.setAttribute('data-current-index', String(index));
      const slide = slides[index];
      if (slide && track) {
        track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        goTo(parseInt(thumb.dataset.index, 10));
      });
    });

    if (prev) prev.addEventListener('click', () => {
      goTo(parseInt(gallery.dataset.currentIndex || '0', 10) - 1);
    });
    if (next) next.addEventListener('click', () => {
      goTo(parseInt(gallery.dataset.currentIndex || '0', 10) + 1);
    });

    // Sync current index cuando el user scrollea manualmente
    let scrollTimeout;
    if (track) {
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const cx = track.scrollLeft + track.clientWidth / 2;
          let closest = 0;
          let minDist = Infinity;
          slides.forEach((s, i) => {
            const mid = s.offsetLeft + s.clientWidth / 2;
            const dist = Math.abs(cx - mid);
            if (dist < minDist) { minDist = dist; closest = i; }
          });
          gallery.setAttribute('data-current-index', String(closest));
          thumbs.forEach((t, i) => t.classList.toggle('is-active', i === closest));
          dots.forEach((d, i) => d.classList.toggle('is-active', i === closest));
        }, 120);
      });
    }
  }

  // ---------- Sticky ATC mobile ----------
  if (stickyBar && atcBtn) {
    // Sacamos el sticky bar del stacking context de .product-page
    // (que tiene isolation: isolate). Al moverlo al body queda
    // libre para competir en z-index contra TODAS las secciones.
    if (stickyBar.parentElement !== document.body) {
      document.body.appendChild(stickyBar);
    }
    // Removemos el atributo hidden — controlamos visibilidad
    // solo con [data-visible] + transform/opacity (transiciones).
    stickyBar.removeAttribute('hidden');

    // 2 flags que combinamos: el ATC principal está fuera de viewport
    // Y el footer/pie NO está en viewport (para no llegar a esa zona).
    let atcOut = false;
    let footerIn = false;

    const applyVisible = () => {
      const shouldShow = atcOut && !footerIn;
      if (shouldShow) {
        stickyBar.setAttribute('data-visible', '');
        stickyBar.setAttribute('aria-hidden', 'false');
      } else {
        stickyBar.removeAttribute('data-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
      }
    };

    // Observer del ATC principal: cuando NO se ve, el sticky puede aparecer.
    const ioAtc = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          atcOut = false;
        } else if (entry.boundingClientRect.top < 0) {
          atcOut = true;
        }
      });
      applyVisible();
    }, { threshold: 0 });
    ioAtc.observe(atcBtn);

    // Observer del footer/recomendaciones/fin de la PDP: cuando entra
    // al viewport, ocultamos el sticky para no molestar en esa zona.
    const stopAnchor =
      document.querySelector('footer, .site-footer, [data-site-footer]') ||
      document.querySelector('.product-page__recommendations, .pdp-recs') ||
      document.querySelector('.product-page').nextElementSibling;
    if (stopAnchor) {
      const ioStop = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          footerIn = entry.isIntersecting;
        });
        applyVisible();
      }, { threshold: 0, rootMargin: '0px 0px -20% 0px' });
      ioStop.observe(stopAnchor);
    }

    // Click del botón sticky → dispara click del ATC principal
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        if (atcBtn.disabled) return;
        stickyBtn.classList.add('is-loading');
        atcBtn.click();
        setTimeout(() => stickyBtn.classList.remove('is-loading'), 800);
      });
    }
    // Sincroniza estado 'is-added' con el ATC principal.
    const syncAdded = () => {
      if (atcBtn.classList.contains('is-added')) {
        stickyBtn.classList.add('is-added');
        setTimeout(() => stickyBtn.classList.remove('is-added'), 1600);
      }
    };
    new MutationObserver(syncAdded).observe(atcBtn, { attributes: true, attributeFilter: ['class'] });
  }

  // ---------- Countdown ----------
  const cd = root.querySelector('[data-countdown]');
  if (cd) {
    const endStr = cd.dataset.end;
    const endTime = endStr ? new Date(endStr).getTime() : NaN;
    const timeEl = cd.querySelector('[data-countdown-time]');
    if (!isNaN(endTime) && timeEl) {
      const tick = () => {
        const diff = endTime - Date.now();
        if (diff <= 0) {
          cd.hidden = true;
          clearInterval(interval);
          return;
        }
        cd.hidden = false;
        cd.setAttribute('data-active', '');
        const d = Math.floor(diff / (1000 * 60 * 60 * 24));
        const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const m = Math.floor((diff / (1000 * 60)) % 60);
        const s = Math.floor((diff / 1000) % 60);
        const parts = [];
        if (d > 0) parts.push(d + 'd');
        parts.push(String(h).padStart(2, '0') + 'h');
        parts.push(String(m).padStart(2, '0') + 'm');
        parts.push(String(s).padStart(2, '0') + 's');
        timeEl.textContent = parts.join(' ');
      };
      tick();
      let interval = setInterval(tick, 1000);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) { if (interval) { clearInterval(interval); interval = null; } }
        else if (!interval) { tick(); interval = setInterval(tick, 1000); }
      });
    }
  }

  // ---------- Features modal ----------
  const modal = root.querySelector('[data-pdp-modal]');
  if (modal) {
    const titleEl = modal.querySelector('[data-pdp-modal-title]');
    const bodyEl = modal.querySelector('[data-pdp-modal-body]');
    const closeBtn = modal.querySelector('[data-pdp-modal-close]');

    root.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-pdp-modal-open]');
      if (!opener) return;
      const col = opener.closest('.pdp-block-features__col');
      const tpl = col && col.querySelector('[data-pdp-modal-content]');
      if (titleEl) titleEl.textContent = opener.dataset.modalTitle || '';
      if (bodyEl && tpl) bodyEl.innerHTML = tpl.innerHTML;
      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', '');
    });

    const close = () => {
      if (typeof modal.close === 'function') modal.close();
      else modal.removeAttribute('open');
    };
    if (closeBtn) closeBtn.addEventListener('click', close);
    modal.addEventListener('click', (e) => {
      if (e.target === modal) close();
    });
  }

  // ---------- Descripción expandible (múltiples instancias) ----------
  // La descripción se renderiza 2 veces en el DOM (una en la col de la
  // galería para desktop, otra en el info panel para mobile). Enganchamos
  // TODAS y evaluamos overflow cuando cada una es visible.
  const descriptions = root.querySelectorAll('[data-pdp-description]');
  descriptions.forEach((description) => {
    const toggle = description.querySelector('[data-pdp-description-toggle]');
    const body = description.querySelector('[data-pdp-description-body]');
    if (!toggle || !body) return;

    const evaluateOverflow = () => {
      // requestAnimationFrame para que el layout esté aplicado antes de medir
      requestAnimationFrame(() => {
        if (description.offsetParent === null) return; // hidden por display:none
        const contentIsBigger = body.scrollHeight > body.clientHeight + 8;
        if (!contentIsBigger && !description.hasAttribute('data-expanded')) {
          description.setAttribute('data-expanded', '');
          toggle.hidden = true;
        } else if (contentIsBigger && toggle.hidden) {
          toggle.hidden = false;
        }
      });
    };

    evaluateOverflow();
    // Re-evaluar en resize (el ancho cambia el número de líneas)
    window.addEventListener('resize', evaluateOverflow);

    toggle.addEventListener('click', () => {
      const expanded = description.hasAttribute('data-expanded');
      if (expanded) {
        description.removeAttribute('data-expanded');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        description.setAttribute('data-expanded', '');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ---------- Compartir ----------
  const shareModal = document.querySelector('[data-pdp-share-modal]');
  const openShareModal = (title, url) => {
    if (!shareModal) return;
    // Actualizar todos los href/mailto
    const enc = encodeURIComponent;
    const text = enc(title + ' — ' + url);
    const links = {
      whatsapp: `https://api.whatsapp.com/send?text=${text}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`,
      twitter: `https://twitter.com/intent/tweet?text=${text}`,
      telegram: `https://t.me/share/url?url=${enc(url)}&text=${enc(title)}`,
      email: `mailto:?subject=${enc(title)}&body=${enc(url)}`,
    };
    shareModal.querySelectorAll('[data-pdp-share-link]').forEach((a) => {
      const key = a.getAttribute('data-pdp-share-link');
      if (links[key]) a.href = links[key];
    });
    // Copiar botón
    const copyBtn = shareModal.querySelector('[data-pdp-share-copy]');
    if (copyBtn) {
      copyBtn.onclick = async () => {
        try {
          if (navigator.clipboard) await navigator.clipboard.writeText(url);
          else window.prompt('Copiar enlace:', url);
          copyBtn.classList.add('is-copied');
          const label = copyBtn.querySelector('[data-pdp-share-copy-label]');
          if (label) {
            const orig = label.textContent;
            label.textContent = '¡Copiado!';
            setTimeout(() => { label.textContent = orig; copyBtn.classList.remove('is-copied'); }, 1500);
          }
        } catch (_) {}
      };
    }
    if (typeof shareModal.showModal === 'function') shareModal.showModal();
    else shareModal.setAttribute('open', '');
  };

  const closeShareModal = () => {
    if (!shareModal) return;
    if (typeof shareModal.close === 'function') shareModal.close();
    else shareModal.removeAttribute('open');
  };

  if (shareModal) {
    const closeBtn = shareModal.querySelector('[data-pdp-share-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeShareModal);
    shareModal.addEventListener('click', (e) => {
      if (e.target === shareModal) closeShareModal();
    });
  }

  // Delegación de click en cualquier [data-share] del root o del sticky (que
  // está en body). Se hace a nivel document para cubrir ambos.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-share]');
    if (!btn) return;
    e.preventDefault();
    const title = btn.dataset.shareTitle || document.title;
    const url = btn.dataset.shareUrl || window.location.href;
    openShareModal(title, url);
  });

  // ---------- Add to Cart (ajax) ----------
  // Handler unificado: se llama tanto por click en el ATC como por submit del form.
  // Previene navegacion, hace fetch a /cart/add.js, y abre el cart drawer.
  //
  // OJO: cuando hay una oferta activa de MW Marketing Offers (volume bundle,
  // bxgy, bogo, bundle offer, product addons), MW intercepta el ATC para
  // agregar el bundle/oferta correcta. Si nosotros llamamos preventDefault
  // primero, MW nunca recibe el evento y solo se agrega 1 item plano.
  // Detectamos ofertas MW activas mirando si algun custom element MW tiene
  // altura > 0 (Y si mwMarketingOffersHelper esta presente). En ese caso
  // NO interceptamos — dejamos que MW haga su trabajo.
  const hasActiveMwOffer = () => {
    if (!window.mwMarketingOffersHelper) return false;
    const mwTags = [
      'mw-volume-bundle', 'mw-bxgy-same-product', 'mw-bundle-offer',
      'mw-bundle-product', 'mw-bogo-offer', 'mw-products-in-bundle',
      'mw-product-addons', 'mw-tier-prices', 'mw-build-offer'
    ];
    return mwTags.some((tag) => {
      const el = document.querySelector(tag);
      return el && el.offsetHeight > 20; // > 20px = MW renderizo algo real
    });
  };

  // Interceptar navegaciones a /cart que apps de terceros (ej MW Marketing
  // Offers) disparan despues de agregar un bundle. En su lugar, refrescamos
  // el cart drawer del theme y lo abrimos.
  //
  // Usamos Navigation API (Chrome 102+ / Edge / Opera) porque Chrome moderno
  // bloquea Object.defineProperty en Location.prototype.href, y muchas apps
  // usan window.location.href = ... — un metodo que no podemos monkey-patch
  // desde afuera. Navigation API es el hook oficial para esto.
  //
  // Firefox y Safari no lo soportan aun — ahi el redirect a /cart procede
  // normal (comportamiento por default, no rompe nada).
  let lastAtcClickAt = 0;
  const isCartRedirect = (pathname) => {
    if (!pathname) return false;
    // /cart, /cart/, pero NO /cart/add ni cualquier subpath
    return pathname === '/cart' || pathname === '/cart/';
  };
  const openDrawerInstead = () => {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'mw-redirect' } }));
  };
  if (window.navigation && (window.mwMarketingOffersHelper || document.querySelector('[data-app-bundle]'))) {
    window.navigation.addEventListener('navigate', (ev) => {
      let pathname = '';
      try { pathname = new URL(ev.destination.url).pathname; } catch (_) { return; }
      if (!isCartRedirect(pathname)) return;
      // Solo interceptamos si el redirect viene inmediatamente despues de un
      // ATC (~3s) — asi no rompemos clicks intencionales del user hacia /cart
      // desde el header, footer, u otros lugares.
      if (Date.now() - lastAtcClickAt > 3000) return;
      ev.preventDefault();
      openDrawerInstead();
    });
  }

  const doAddToCart = async (e) => {
    if (!atcBtn || atcBtn.disabled) return;
    // SIEMPRE prevenimos la navegacion del submit del form nativo.
    // Sin esto, tras agregar (por MW o por nosotros) el navegador manda
    // al usuario a /cart en vez de mantenerlo en la PDP con el drawer.
    e.preventDefault();
    // Registrar timestamp para que el interceptor de <a href="/cart"> sepa
    // que este click viene del ATC (para NO interceptar clicks legitimos
    // de otras partes del sitio hacia /cart).
    lastAtcClickAt = Date.now();
    // Si MW tiene una oferta activa, MW intercepta el mismo click (bubble)
    // y agrega el bundle correcto. NO llamamos nuestro fetch para no duplicar.
    if (hasActiveMwOffer()) {
      // Refrescar el drawer del theme despues de que MW termine su add.
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'mw' } }));
      }, 800);
      return;
    }
    e.stopPropagation();
    const variantId = (variantIdInput && variantIdInput.value) || root.getAttribute('data-current-variant-id');
    if (!variantId) return;
    const qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    atcBtn.disabled = true;
    atcBtn.classList.add('is-loading');
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ id: Number(variantId), quantity: qty })
      });
      const payload = await r.json().catch(() => null);
      if (!r.ok || (payload && payload.status && payload.status >= 400)) {
        throw new Error((payload && (payload.description || payload.message)) || 'add failed');
      }
      atcBtn.classList.remove('is-loading');
      atcBtn.classList.add('is-added');
      const label = atcBtn.querySelector('.pdp-block-buy__atc-label') || atcBtn.querySelector('.product-page__atc-label');
      const prevLabel = label ? label.textContent : '';
      if (label) label.textContent = '✓ AGREGADO';
      setTimeout(() => {
        atcBtn.classList.remove('is-added');
        if (label) label.textContent = prevLabel;
      }, 1600);
      // Disparar cart:updated para que el cart-drawer refresque + auto-abra
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'pdp' } }));
      if (window.NQLN && typeof window.NQLN.syncCartBadge === 'function') {
        window.NQLN.syncCartBadge();
      }
      if (window.NQLN && typeof window.NQLN.broadcastCartUpdate === 'function') {
        window.NQLN.broadcastCartUpdate();
      }
    } catch (err) {
      atcBtn.classList.remove('is-loading');
      const label = atcBtn.querySelector('.pdp-block-buy__atc-label') || atcBtn.querySelector('.product-page__atc-label');
      if (label) {
        const orig = label.textContent;
        label.textContent = 'ERROR';
        setTimeout(() => { label.textContent = orig; }, 1600);
      }
    } finally {
      atcBtn.disabled = false;
    }
  };

  if (atcBtn) {
    // Capturamos click ANTES de que el form intente submit (capture:true)
    atcBtn.addEventListener('click', doAddToCart, true);
    const form = atcBtn.closest('form');
    if (form) {
      form.addEventListener('submit', doAddToCart);
    }
  }
})();
